<template>
    <div class='subscribe-container'>
        <h1 class='sub-header'>STAY IN THE KNOW </h1>
        <p class='sub-header-2'>Sign up to hear about new products, offers and tasting events by email. </p>
        <!-- <p class='sub-text'>For all the latest updates in your inbox</p> -->
        <div v-show='!subscribe_success' class='subscription-field-container'>
            <input class='subscribe-text-box' type="text" autocomplete="off" v-model='email_address' placeholder="Email Address" />
            <button class='subscribe-button' @click='subscribeEmail'>Subscribe <i class="fa-regular fa-arrow-right"></i></button>
        </div>
        <div class='success-message' v-show='subscribe_success'>
             <p>Your email address has been successfully subscribed.</p>
        </div>
        <p class='error-message'>{{errors}}</p>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";

export default {
    data(){
        return{
            email_address: '',
            errors: '',
            subscribe_success: false
        }
    },
    methods:{
        async subscribeEmail() {
            let response = await fetch('/api/user/subscribe-email', {
                method: 'POST',
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email_address : this.email_address,
                }),
            });

            let results = await checkAuth(response);
            this.errors = {};

            if (response.status === 200) {
                 this.errors = '';
                 
                if(results.errors.length === 0) {
                    this.subscribe_success = true;
                } 
                else {
                    this.errors = results.errors.email;
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.sub-header{
    font-weight: 400;
    font-size: 2rem;
    margin: 0;

    @media(max-width: 768px){
        font-size: 1.6rem;
    }
}

.sub-header-2{
    font-size: 1.4rem;
    margin: 0;

    @media(max-width: 768px){
        font-size: 1.2rem;
    }
}

.sub-text{
    font-size: 1rem;
}

.subscribe-text-box{
    padding: 12px;
    width: 400px;
    border-radius: 8px 0px 0px 8px;
    outline: none;
    border: 1px solid #28353365;
    
    @media(max-width: 768px){
        border-radius: 8px;
        width: auto;
        height: 30px;
    }
}

.subscription-field-container{
    display: flex;
    margin-top: 12px;
    @media(max-width: 768px){
        flex-direction: column;
        gap: 12px;
    }
}

.subscribe-button{
    background-color: #184A2E;
    color: white;
    font-size: 1rem;
    padding: 16px;
    font-weight: 400;
    border-radius: 0px 8px 8px 0px;
    cursor: pointer;
        @media(max-width: 768px){
        border-radius: 8px;
        width: 100%;
    }
}

.subscribe-container{
    display: flex;
    flex-direction: column;
    gap: 12px;

    padding-left: 16px;

    @media(max-width: 768px){
        padding-left: 0px;
    }
}

.error-message{
    color: red;
    margin-top: -4px;
    margin-left: 4px;
}

.success-message{
    font-size: 1.2rem;
    color: var(--maj-dark-green);
    font-weight: 600;
}
</style>